import { inject, Injectable } from '@angular/core';
import { ProfileSelectorDetails } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { BehaviorSubject, Subject } from 'rxjs';
import { ProfileSelectorAdapterService } from '../../adapters/profile-selector/profile-selector-adapter.service';
import { SkyBonusNuTravelAdapterService } from '../../adapters/profile-selector/skybonus-nutravel-adapter/skybonus-nutravel-adapter.service';
import {
  DashboardResponse,
  loginAndGetDashboardResponse,
  OauthAEMConfig
} from '../../models/login';
import { UserSessionService } from '../../services/login/data-services/user-session/user-session.service';
import { LogoutService } from '../../services/logout/logout.service';
import { ProfileSelectorService } from '../../services/profile-selector/data-services/profile-selector.service';
import { ProfileSelectorUtilService } from '../../utils/profile-selector/profile-selector-util.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorFacadeBaseService {
  profileSelectorAdapterService = inject(ProfileSelectorAdapterService);
  profileSelectorContentService = inject(ProfileSelectorService);
  profileSelectorUtilService = inject(ProfileSelectorUtilService);
  userSession = inject(UserSessionService);
  logOut = inject(LogoutService);
  skyBonusNuTravelAdapterService = inject(SkyBonusNuTravelAdapterService);
  profileDetails$ = new BehaviorSubject<ProfileSelectorDetails | null>(null);
  displayTermsUse$ = new BehaviorSubject<boolean>(false);
  fromProfileStandAlone$ = new BehaviorSubject<boolean>(false);
  isDashBoardResponse$ = new BehaviorSubject<boolean>(false);
  isLoggedInStatus$ = new BehaviorSubject<boolean | undefined>(false);
  personalSelectedState$ = new BehaviorSubject<boolean>(false);
  businessSelectedState$ = new BehaviorSubject({
    selectedState: false,
    accountIndex: 0
  });

  unsubscribe$ = new Subject();
  authConfig = {} as OauthAEMConfig;
  dashboardData = {} as loginAndGetDashboardResponse | DashboardResponse;
  refreshURL = '';
  queryParams = {} as { [key: string]: string };
  paramsToIgnore: string[] = [];
  pingDomain = '';
  queryParamKeys: string[] = [];
  logoutPingUrl = '';
}
